module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"speed":"Speed","margin":"Margin","popularity":"Popularity","stock":"Stock","crossSelling":"Cross-Selling","strategic":"Strategic"},"es":{"speed":"Velocidad","margin":"Margen","popularity":"Popularidad","stock":"Stock","crossSelling":"Cross-Selling","strategic":"Stratégico"}}')
  delete Component.options._Ctor
}
